/* eslint-disable react/no-unescaped-entities */
import React from 'react'
import { Link, withAssetPrefix } from 'gatsby'
import Layout from './layout.js'
import data from '../components/content/classic-home/classic-home.en-XC.yaml'
import Image from '../templates/Image'

function ClassicHome({ location }) {
  const thirdPartyChoices = data.content.third_party.carts.choices.map(
    (choice, id) => {
      return (
        <li key={id}>
          <Link className="dx-no-eel" to={choice.url}>
            <img
              src={withAssetPrefix(choice.img)}
              alt={`${choice.title} logo`}
            />
          </Link>
        </li>
      )
    },
  )

  const finMgmtChoices = data.content.third_party.carts.choices.map(
    (choice, id) => {
      return (
        <li key={id}>
          <Link className="dx-no-eel" to={choice.url}>
            <img
              src={withAssetPrefix(choice.img)}
              alt={`${choice.title} logo`}
            />
          </Link>
        </li>
      )
    },
  )

  const specialityChoices = data.content.third_party.specialty.choices.map(
    (choice, id) => {
      return (
        <li key={id}>
          <Link className="dx-no-eel" to={choice.url}>
            <img
              src={withAssetPrefix(choice.img)}
              alt={`${choice.title} logo`}
            />
          </Link>
        </li>
      )
    },
  )

  return (
    <Layout layout="full-width" location={location}>
      <div className="homepage-notification hide">
        <div className="section__content">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 16 16"
          >
            <g fill="#FFF" fillRule="evenodd" transform="translate(-1 -1)">
              <polygon fill="none" points="0 18 18 18 18 0 0 0" />
              <path d="M8,10 L10,10 L10,4 L8,4 L8,10 Z M8,14 L10,14 L10,12 L8,12 L8,14 Z M9,1 C4.589,1 1,4.59 1,9 C1,13.412 4.589,17 9,17 C13.411,17 17,13.412 17,9 C17,4.59 13.411,1 9,1 L9,1 Z" />
            </g>
          </svg>
        </div>
      </div>

      <section className="section section--grad-blue">
        {/* <div className="homepage-marginBot36 homepage-cov19">
                    <Link id="cov19banner" className="homepage-notice dx-no-eel" to={data.content.notifications.url} target="_blank"><span className="strong">{data.content.notifications.description1}</span> {data.content.notifications.description2}</Link>
                </div> */}
        <div className="section__content">
          <h2 className="homepage-products-title">
            {data.content.products.title}
          </h2>
          <div className="homepage-products">
            <Link
              className="homepage-product"
              to={data.content.products.checkout.url}
            >
              <div className="grid">
                <h3 className="homepage-product-title">
                  {data.content.products.checkout.title}
                </h3>
                <Image
                  className="homepage-product-img"
                  src={data.content.products.checkout.img}
                  alt={`${data.content.products.checkout.title} icon`}
                />
              </div>
              <p className="homepage-product-desc">
                {data.content.products.checkout.description}
              </p>
            </Link>

            <Link
              className="homepage-product"
              to={data.content.products.partners.url}
            >
              <div className="grid">
                <h3 className="homepage-product-title">
                  {data.content.products.partners.title}
                </h3>
              </div>
              <p className="homepage-product-desc">
                {data.content.products.partners.description}
              </p>
            </Link>

            <Link
              className="homepage-product"
              to={data.content.products.subscriptions.url}
            >
              <div className="grid">
                <h3 className="homepage-product-title">
                  {data.content.products.subscriptions.title}
                </h3>
                <Image
                  className="homepage-product-img"
                  src={data.content.products.subscriptions.img}
                  alt={`${data.content.products.subscriptions.title} icon`}
                />
              </div>
              <p className="homepage-product-desc">
                {data.content.products.subscriptions.description}
              </p>
            </Link>

            <Link
              className="homepage-product"
              to={data.content.products.payouts.url}
            >
              <div className="grid">
                <h3 className="homepage-product-title">
                  {data.content.products.payouts.title}
                </h3>
                <Image
                  className="homepage-product-img"
                  src={data.content.products.payouts.img}
                  alt={`${data.content.products.payouts.title} icon`}
                />
              </div>
              <p className="homepage-product-desc">
                {data.content.products.payouts.description}
              </p>
            </Link>

            <Link
              className="homepage-product"
              to={data.content.products.invoicing.url}
            >
              <div className="grid">
                <h3 className="homepage-product-title">
                  {data.content.products.invoicing.title}
                </h3>
                <Image
                  className="homepage-product-img"
                  src={data.content.products.invoicing.img}
                  alt={`${data.content.products.invoicing.title} icon`}
                />
              </div>
              <p className="homepage-product-desc">
                {data.content.products.invoicing.description}
              </p>
            </Link>

            <Link
              className="homepage-product"
              to={data.content.products.cards.url}
            >
              <div className="grid">
                <h3 className="homepage-product-title">
                  {data.content.products.cards.title}
                </h3>
                <Image
                  className="homepage-product-img"
                  src={data.content.products.cards.img}
                  alt={`${data.content.products.cards.title} icon`}
                />
              </div>
              <p className="homepage-product-desc">
                {data.content.products.cards.description}
              </p>
            </Link>
          </div>
          {/* eslint-disable-next-line react/no-unknown-property */}
          <div align="right" style={{ paddingRight: '10px' }}>
            <Link to="/docs/" style={{ color: '#f5f7fa' }}>
              See all docs
            </Link>
          </div>
        </div>
      </section>

      <section className="section section--gray">
        <div className="section__content section__content--mid">
          <h2>{data.content.try.title}</h2>

          <div className="text-center">
            <img
              src={withAssetPrefix('/img/docs/checkout/vertical_web.svg')}
              width="400"
            />
            <br />
            <br />
          </div>
          {data.content.try.description}
          <div className="dx-content">
            <pre lang="html">
              &lt;script
              src="https://www.paypal.com/sdk/js?client-id=sb"&gt;&lt;/script&gt;
              &lt;script&gt;paypal.Buttons().render('body');&lt;/script&gt;
            </pre>
          </div>
          <br />

          <p>
            {data.content.try.next}{' '}
            <Link className="home-product-link__product" to="/docs/checkout/">
              {' '}
              {data.content.try.nexturltext}
            </Link>{' '}
            {data.content.try.nexttext}
          </p>
        </div>
      </section>

      <section className="section section--gray">
        <div className="section__content section__content--mid">
          <h2>{data.content.third_party.title}</h2>
          <p>{data.content.third_party.description}</p>

          <div className="grid">
            <div className="grid__item grid__item--4 center">
              <h3>{data.content.third_party.carts.title}</h3>
              <p>{data.content.third_party.carts.description}</p>

              <ul className="list-img">
                {thirdPartyChoices}
                <li>
                  <Link to={data.content.third_party.carts.more.url}>
                    {data.content.third_party.carts.more.title}
                  </Link>
                </li>
              </ul>
            </div>
            <div className="grid__item grid__item--4 center">
              <h3>{data.content.third_party.fin_mgmt.title}</h3>
              <p>{data.content.third_party.fin_mgmt.description}</p>

              <ul className="list-img">
                {finMgmtChoices}
                <li>
                  <Link to={data.content.third_party.fin_mgmt.more.url}>
                    {data.content.third_party.fin_mgmt.more.title}
                  </Link>
                </li>
              </ul>
            </div>
            <div className="grid__item grid__item--4 center">
              <h3>{data.content.third_party.specialty.title}</h3>
              <p>{data.content.third_party.specialty.description}</p>

              <ul className="list-img">
                {specialityChoices}
                <li>
                  <Link to={data.content.third_party.specialty.more.url}>
                    {data.content.third_party.specialty.more.title}
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <p className="switchclassic">
        <Link to={data.content.switch_new_url}>
          {data.content.switch_new_title}
        </Link>
      </p>
    </Layout>
  )
}

export default ClassicHome
